import React from "react";

const DemoSection = () => {
  return (
    <section className="w-full max-w-[1180px] mx-auto md:px-7 px-4 flex flex-col gap-8">
      <div className="flex flex-col items-center gap-3">
        <h2 className="font-jakarta font-extrabold text-[#0F1B2D] text-center text-[2rem] sm:text-[2.4rem] md:text-[2.875rem] leading-[1.24] tracking-[-0.02em]">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
            45 seconds.
          </span>{" "}
          Real Windows work.
        </h2>
        <p className="font-inter font-normal text-[#33425A] text-center text-[1rem] sm:text-[1.125rem] md:text-[1.3125rem] leading-[1.5] max-w-[720px]">
          Watch an email drafted in Outlook, a doc written in Word, and a reply
          sent on LinkedIn — all by voice.
        </p>
      </div>

      <div className="w-full rounded-[26px] bg-[#0F1B2D] h-[260px] sm:h-[340px] md:h-[420px] flex items-center justify-center">
        {/* Video placeholder */}
      </div>
    </section>
  );
};

export default DemoSection;
